import { render, staticRenderFns } from "./OTAManagement.vue?vue&type=template&id=7b5133c3&scoped=true&"
import script from "./OTAManagement.vue?vue&type=script&lang=js&"
export * from "./OTAManagement.vue?vue&type=script&lang=js&"
import style0 from "./OTAManagement.vue?vue&type=style&index=0&id=7b5133c3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5133c3",
  null
  
)

export default component.exports